import { useEffect, useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { useAuthState } from "../../context/AuthContext";

const EnergoTooltip = ({position, color, style, tKey, msg}) => {

    const {tooltips, tooltipsTrigger} = useAuthState();
    const [helpText, setHelpText] = useState(msg? msg : "");

    const textColor = color? color: "text-energo";
    const [show, setShow] = useState(false);
    const target = useRef(null);

    useEffect(() => {
        if (tooltips && tooltips.length > 0 && !msg) {
            console.log(tooltips)
            var wanted = tooltips.find(t => t && t.code != null && tKey != null && t.code.toString() === tKey.toString());
            if (wanted) {
                setHelpText(wanted.help_text);
            }
        }
    }, [tooltips, msg])

    return (
        <div key={`toolt-${tKey}`}>
            {tooltipsTrigger && helpText !== "" &&
                <>
                    <div ref={target}>
                        <FaInfoCircle
                            style={style}
                            className={textColor}
                            onMouseEnter={() => setShow(true)}
                            onMouseLeave={() => setShow(false)}
                            onClick={e => {e.preventDefault(); setShow(true)}}
                        />
                    </div>
                    <Overlay 
                        target={target.current} 
                        show={show} 
                        placement={position}
                        rootClose={true}
                        rootCloseEvent="click" 
                        onHide={() => setShow(false)}
                    >
                        {(props) => (
                            <Tooltip id="overlay" {...props}>
                                {helpText}
                            </Tooltip>
                        )}
                    </Overlay>
                </>
            }
        </div>
    )
}
export default EnergoTooltip;